import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function appLearnMoreGetStarted({ uid, name }) {
  pushClevertapEvent('Apps Find Out More Get Started', {
    'App Name': name,
    'App ID': uid,
  });
}

export function appLearnMoreCategoryBreadcrumb({ uid, name, categoryName }) {
  pushClevertapEvent('Apps Category Breadcrumb', {
    'App Name': name,
    'App ID': uid,
    'Category Name': categoryName,
  });
}
